import React, { ReactElement, ReactNode } from 'react';
import { Button } from 'react-bootstrap';

interface SecondaryButtonProps {
    id?: string;
    className?: string;
    children: ((ReactElement<any, any> & ReactNode) & ReactNode) | ReactNode[] | string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const SecondaryButton = (props: SecondaryButtonProps) => {
    const { className, onClick } = props;

    return (
        <Button
            className={`secondary-button ${className}`}
            variant="secondary"
            type="button"
            onClick={onClick}
        >
            {props.children}
        </Button>
    );
};

export default SecondaryButton;
